import React from 'react'

import Mouse from '../../assets/mouse.svg'

import scrollToReadStyles from './scrollToRead.module.scss'

const ScrollToRead = ({ className, classes }) => (
  <div
    className={`${classes} ${className} ${scrollToReadStyles.cta}`}
    aria-hidden="true"
  >
    <Mouse className={`ctaMouse ${scrollToReadStyles.ctaMouse}`} />
    <p className={scrollToReadStyles.ctaLabel}>Role para continuar</p>
  </div>
)

export default ScrollToRead
